// src/api/auth.js
import api from './config';

export const authAPI = {
  // Login
  login: async (username, password) => {
    const preferredCompanyId = localStorage.getItem('currentCompanyId') || null;
    const response = await api.post('/auth/login', {
      username,
      password,
      ...(preferredCompanyId && { preferredCompanyId }),
    });
    
    // Guardar token y usuario en localStorage
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      
      // 🔧 FIX: Guardar companyId
      const user = response.data.user;
      if (user.company_id) {
        console.log('✅ Guardando company_id:', user.company_id);
        localStorage.setItem('companyId', user.company_id);
      } else if (user.companyId) {
        console.log('✅ Guardando companyId:', user.companyId);
        localStorage.setItem('companyId', user.companyId);
      } else {
        // Si el user no tiene companyId, intentar obtenerlo de employees
        console.log('⚠️ User sin companyId, obteniendo de employees...');
        try {
          const employeesResponse = await api.get('/employees?estado=activo');
          if (employeesResponse.data && employeesResponse.data.length > 0) {
            const companyId = employeesResponse.data[0].company_id;
            localStorage.setItem('companyId', companyId);
            console.log('✅ CompanyId obtenido de employees:', companyId);
          }
        } catch (e) {
          console.warn('No se pudo obtener companyId de employees:', e);
        }
      }
    }
    
    return response.data;
  },

  // Verificar sesión con el backend
  verifySession: async () => {
    try {
      const response = await api.get('/auth/me');
      
      // 🔧 FIX: Actualizar companyId si falta
      if (response.data.user) {
        const user = response.data.user;
        const companyId = user.company_id || user.companyId;
        
        if (companyId && !localStorage.getItem('companyId')) {
          console.log('✅ Actualizando companyId desde sesión:', companyId);
          localStorage.setItem('companyId', companyId);
        } else if (!companyId && !localStorage.getItem('companyId')) {
          // Intentar obtener de employees como último recurso
          try {
            const employeesResponse = await api.get('/employees?estado=activo');
            if (employeesResponse.data && employeesResponse.data.length > 0) {
              const fallbackCompanyId = employeesResponse.data[0].company_id;
              localStorage.setItem('companyId', fallbackCompanyId);
              console.log('✅ CompanyId obtenido de employees:', fallbackCompanyId);
            }
          } catch (e) {
            console.warn('No se pudo obtener companyId:', e);
          }
        }
      }
      
      return response.data;
    } catch (error) {
      // Si hay error (401, network, etc), lanzar error
      throw error;
    }
  },

  // Register (solo para admin)
  register: async (userData) => {
    const response = await api.post('/auth/register', userData);
    return response.data;
  },

  // Switch Company
  switchCompany: async (companyId) => {
    const response = await api.post('/auth/switch-company', { companyId });

    // Actualizar token y usuario en localStorage
    if (response.data.success && response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      localStorage.setItem('companyId', companyId);

      console.log('✅ Compañía cambiada a:', companyId);
    }

    return response.data;
  },

  // Logout
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('companyId');
    // currentCompanyId se conserva para restaurar la última compañía en el próximo login
    // No redirigir automáticamente, dejar que App.jsx maneje el estado
  },

  // Obtener usuario actual del localStorage
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    
    try {
      const user = JSON.parse(userStr);
      
      // 🔧 FIX: Asegurar que companyId esté disponible
      if (!user.companyId && !user.company_id) {
        const storedCompanyId = localStorage.getItem('companyId');
        if (storedCompanyId) {
          user.companyId = storedCompanyId;
        }
      }
      
      return user;
    } catch (e) {
      console.error('Error parsing user:', e);
      return null;
    }
  },

  // Verificar si hay sesión activa
  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },

  // Cambiar contraseña
  changePassword: async (currentPassword, newPassword) => {
    const response = await api.post('/auth/change-password', {
      currentPassword,
      newPassword
    });
    return response.data;
  }
};